module.exports = __webpack_public_path__ + "img/all-programs.013e964c.webp";